window.$ = window.JQuery = require('jquery');

import Alpine from 'alpinejs';
import dialog from '@fylgja/alpinejs-dialog';
import calendar from './components/calendar';
import tabs from './components/tabs';
import complaintsForm from './components/complaints-form';
import { gsap } from 'gsap'; 
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(ScrollTrigger,DrawSVGPlugin, SplitText);


window.Alpine = Alpine;

Alpine.data('calendar', calendar);
Alpine.data('tabs', tabs);
Alpine.plugin(dialog);
Alpine.start();

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const swiper = new Swiper('.swiper-container', {
  modules: [Navigation, Pagination],
  slidesPerView: 1, 
  spaceBetween: 10, 
  pagination: {
      el: '.swiper-pagination',
      clickable: true, 
  },
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
  breakpoints: {
      768: {
          slidesPerView: 2,
      },
      767: {
          slidesPerView: 1,
      },
  },
});

const storyswiper = new Swiper('.swiper-story-container', {
    modules: [Navigation, Pagination],
    slidesPerView: 1, 
    spaceBetween: 100, 
    pagination: {
        el: '.swiper-pagination',
        clickable: true, 
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
  });

const newsswiper = new Swiper('.swiper-news-container', {
    modules: [Navigation, Pagination],
    slidesPerView: 1, 
    spaceBetween: 100, 
    pagination: {
        el: '.swiper-pagination',
        clickable: true, 
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        1441: {
            slidesPerView: 3,
            spaceBetween: 100
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        767: {
            slidesPerView: 1,
            spaceBetween: 10,
        },
    },
  });


$(document).ready(function() {
    giftAid();
    postIndex('#post-filter', '#article-panel-wrapper', '#article-panel-inner-wrapper');
    //list
    postIndex('#list-filter', '#list-panel-wrapper', '#list-panel-inner-wrapper');
    //grid
    postIndex('#grid-filter', '#grid-panel-wrapper', '#grid-panel-inner-wrapper');
    stickySidbar();
    form();
    complaintsForm();
    window.addEventListener("load", () => { animations(); });
    shop();
});

function form() {

    $('.js-previous-positions').hide();
    $('.js-driving-licence').hide();
    $('.js-unspent-cautions').hide();
    $('.js-spent-cautions').hide();

    $('input[name="previous-interview"]').on('change', function() {
        if ($(this).is(':checked') && $(this).val() === 'Yes') {
            $('.js-previous-positions').show();
        } else {
            $('.js-previous-positions').hide();
        }
    });

    $('input[name="driving-licence"]').on('change', function() {
        if ($(this).is(':checked') && $(this).val() === 'Yes') {
            $('.js-driving-licence').show();
        } else {
            $('.js-driving-licence').hide();
        }
    });

    $('input[name="unspent-cautions"]').on('change', function() {
        if ($(this).is(':checked') && $(this).val() === 'Yes') {
            $('.js-unspent-cautions').show();
        } else {
            $('.js-unspent-cautions').hide();
        }
    });

    $('input[name="spent-cautions"]').on('change', function() {
        if ($(this).is(':checked') && $(this).val() === 'Yes') {
            $('.js-spent-cautions').show();
        } else {
            $('.js-spent-cautions').hide();
        }
    });

}

function stickySidbar()
{
    if ($('#sticky-sidbar').length) {
        const $stickySidbar = $('#sticky-sidbar');
        const $articleBlock = $('.article-block');
        const $columnContainer = $stickySidbar.parent();
        const $header = $('.mainmenu');
        let ticking = false;
        let lastScrollY = window.scrollY;

        function updateColumnPosition() {
            const articleBlockRect = $articleBlock[0].getBoundingClientRect();
            const stickySidbarRect = $stickySidbar[0].getBoundingClientRect();
            const columnContainerRect = $columnContainer[0].getBoundingClientRect();
            const headerHeight = $header.outerHeight();

            const baseTopOffset = 16;
            const topOffset = headerHeight + baseTopOffset;
            const bottomOffset = 20; 

            if ($(window).width() >= 1024) {
                const articleBlockTop = articleBlockRect.top;
                const articleBlockBottom = articleBlockRect.bottom;
                const columnHeight = stickySidbarRect.height;
                const containerHeight = columnContainerRect.height;

                let newY = 0;

                if (articleBlockTop <= topOffset && articleBlockBottom >= columnHeight + bottomOffset) {
                    newY = Math.max(0, -articleBlockTop + topOffset);
                    const maxY = containerHeight - columnHeight;
                    newY = Math.min(newY, maxY);
                    const articleBlockMaxY = articleBlockRect.height - columnHeight - bottomOffset;
                    newY = Math.min(newY, articleBlockMaxY);
                } else if (articleBlockBottom < columnHeight + bottomOffset) {
                    newY = Math.min(containerHeight - columnHeight, articleBlockRect.height - columnHeight - bottomOffset);
                }

                $stickySidbar.css('transform', `translateY(${newY}px)`);
            } else {
                $stickySidbar.css('transform', 'translateY(0)');
            }

            ticking = false;
        }

        function onScroll() {
            lastScrollY = window.scrollY;
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    updateColumnPosition();
                    ticking = false;
                });
                ticking = true;
            }
        }

        $(window).on('scroll', onScroll);
        $(window).on('resize', updateColumnPosition);

        updateColumnPosition();
    }
}

function giftAid() {

    if($('#gift_aid').length == 0) {
        return;
      }

    $('#gift_aid').on('change', function() {
        var isChecked = $(this).is(':checked');
        $.ajax({
            url: ajaxscript.ajax_url,
            type: 'POST',
            data: {
                action: 'update_gift_aid',
                gift_aid: isChecked
            },
            success: function(response) {
                $(document.body).trigger('update_checkout');
            }
        });
    });
}

function postIndex(filterSelector, wrapperSelector, innerWrapperSelector) {
    if ($(filterSelector).length === 0) {
        return;
    }

    $(document.body).on('submit', filterSelector, function (event) {
        event.preventDefault();
        loadPostData({
            href: $(filterSelector).attr('action') + '?' + $(filterSelector).serialize(),
            filterSelector,
            wrapperSelector,
            innerWrapperSelector
        });
    });

    $(document.body).on('change', `${filterSelector} [name="category_id"]`, function (event) {
        event.preventDefault();
        loadPostData({
            href: $(filterSelector).attr('action') + '?' + $(filterSelector).serialize(),
            filterSelector,
            wrapperSelector,
            innerWrapperSelector
        });
    });

    $(document.body).on('click', `${wrapperSelector} .pagination a`, function (event) {
        event.preventDefault();
        loadPostData({
            href: $(this).prop('href'),
            filterSelector,
            wrapperSelector,
            innerWrapperSelector
        });
    });
}

function loadPostData({ href, filterSelector, wrapperSelector, innerWrapperSelector }) {
    $('html,body').animate({ scrollTop: $(filterSelector).offset().top - $('#header').height() }, 100);

    const $articlePanelWrapper = $(wrapperSelector);
    $articlePanelWrapper.empty();

    const $gridContainer = $('<div></div>').addClass("grid grid-cols-1 md:grid-cols-3 gap-10");

    for (let i = 0; i < 9; i++) {
        $gridContainer.append(`
            <div role="status" class="animate-pulse space-y-4">
                <div class="w-full h-48 bg-gray-300 rounded-xl dark:bg-gray-700"></div>
                <div class="h-4 bg-gray-200 rounded dark:bg-gray-700 w-3/4"></div>
                <div class="h-4 bg-gray-200 rounded dark:bg-gray-700 w-1/2"></div>
                <span class="sr-only">Loading...</span>
            </div>
        `);
    }

    $articlePanelWrapper.append($gridContainer);

    $(wrapperSelector).load(href + ` ${innerWrapperSelector}`, function () {});

    const stateObj = {};
    window.history.pushState(stateObj, "", href);
}
  

window.stopVideo = function() {
    // For YouTube embeds
    if (document.querySelector('#youtube-player')) {
        let iframe = document.querySelector('#youtube-player');
        iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
    }
    
    // For self-hosted videos
    let video = document.querySelector('[x-ref="self-hosted-video"]');
    if (video) {
        video.pause();
        video.currentTime = 0;
    }
}


function animations() {

    //stars
    if (document.querySelector('.footer-star-one')) {
        gsap.to('.footer-star-one', {
            scale: 1.1,                
            opacity: 0.5,              
            rotation: -15,              
            duration: 1.5,             
            repeat: -1,                
            yoyo: true,                
            ease: 'power1.inOut',      
        });

        gsap.to('.footer-star-two', {
            scale: 1.1,
            opacity: 0.5,
            rotation: -15,             
            duration: 1.5,
            repeat: -1,
            yoyo: true,
            ease: 'power1.inOut',
            delay: 0.75                
        });
    }

    //rays
    if (document.querySelector('.cta-ray--top-right')) {
        gsap.fromTo(
            '.cta-ray--top-right .ray-1',
            { scale: 0.7, opacity: 0.6, transformOrigin: '100% 100%' },
            {
            scale: 1,
            opacity: 1,
            duration: 1.5,
            ease: 'power2.inOut',
            repeat: -1,
            yoyo: true,
            delay: 0,
            }
        );
        
        gsap.fromTo(
            '.cta-ray--top-right .ray-2',
            { scale: 0.8, opacity: 0.8, transformOrigin: '100% 100%' },
            {
            scale: 1,
            opacity: 1,
            duration: 1.5,
            ease: 'power2.inOut',
            repeat: -1,
            yoyo: true,
            delay: 0.2,
            }
        );
        
        gsap.fromTo(
            '.cta-ray--top-right .ray-3',
            { scale: 0.7, opacity: 0.6, transformOrigin: '100% 100%' },
            {
            scale: 1,
            opacity: 1,
            duration: 1.5,
            ease: 'power2.inOut',
            repeat: -1,
            yoyo: true,
            delay: 0.4,
            }
        );
    }
      
    //banners
    if (document.querySelector('.banner--animated')) {
        gsap.to('.banner--animated', {
            scrollTrigger: {
                trigger: '.banner--animated',
                start: 'top 80%',
                onEnter: () => {
                    document.querySelector('.banner--animated').classList.add('show');
                },
                toggleActions: 'play none none reverse',
                once: true, 
            }
        });
    }

    //article parallax
    if (document.querySelector('.article-block')) {

        gsap.fromTo(".article-block .before", 
            { 
                x: "-100%", 
                opacity: 0,
            }, 
            { 
                x: "0%", 
                duration: 1, 
                opacity: 1,
                ease: "power2.out",
            }
        );

        gsap.fromTo(".article-block .after", 
            { 
                x: "100%", 
            }, 
            { 
                x: "0%", 
                duration: 1,
                ease: "power2.out",

            }
        );

        gsap.to(".article-block .before", {
            y: "600px",
            rotation: 0,
            ease: "none",
            scrollTrigger: {
                trigger: ".article-block",
                start: "top bottom",
                end: "bottom top",
                scrub: true,
            }
        });
        gsap.to(".article-block .after", {
            y: "600px",
            ease: "none",
            scrollTrigger: {
                trigger: ".article-block",
                start: "top bottom",
                end: "bottom top",
                scrub: true,
            }
        });
    }

    //blocks
    if (document.querySelector('.js-items-grid')) {
        gsap.from(".js-items-grid .grid-item", {
            opacity: 0,
            y: 20,
            duration: 0.5,
            stagger: 0.2, 
            ease: "power2.out",
            scrollTrigger: {
                trigger: ".js-items-grid",
                start: "top 70%", 
                toggleActions: "play none none none"
            },
        });
    }

    //article blocks
    if (document.querySelector('.swiper-news-container')) {
        gsap.from(".swiper-news-container .latest-article", {
            opacity: 0, 
            y: 20,
            duration: 0.5,
            stagger: 0.2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: ".swiper-news-container",
                start: "top 70%",
                toggleActions: "play none none none"
            },
        });
    }


    //text block
    if (document.querySelector('.shape-one-two')) {
        gsap.to(".shape-one-two .before", {
            y: "10px",
            rotation: 40,
            ease: "none",
            scrollTrigger: {
                trigger: ".shape-one-two",
                start: "top bottom",
                end: "bottom top",
                scrub: true,
            }
        });


        const arrowAnimation = gsap.timeline({ repeat: -1 }); 

        arrowAnimation.to(".shape-one-two .after", {
            x: -5,   
            y: -5,   
            duration: 0.2,
            ease: "power1.inOut",
        })
        .to(".shape-one-two .after", {
            x: 0,    
            y: 0,    
            duration: 0.2,
            ease: "power1.inOut",
        })
        .to(".shape-one-two .after", {
            x: -5,   
            y: -5,   
            duration: 0.2,
            ease: "power1.inOut",
        })
        .to(".shape-one-two .after", {
            x: 0,    
            y: 0,    
            duration: 0.2,
            ease: "power1.inOut",
        })
        .to(".shape-one-two .after", {
            duration: 2,
            ease: "none",
            onComplete: () => arrowAnimation.restart(),
        });
    }

    if (document.querySelector('.swiper-container')) {
        gsap.utils.toArray(".swiper-slide-image").forEach((image) => {
            gsap.fromTo(image, 
                { scale: 1.1 }, 
                {
                    scale: 1, 
                    ease: "power2.out",
                    immediateRender: false,
                    scrollTrigger: {
                        trigger: ".swiper-container",
                        start: "top 80%",
                        end: "bottom top",
                        scrub: true,
                        toggleActions: "play none none reverse",
                    }
                }
            );
        });
    }

    if (document.querySelector('.donate-cta')) {
        gsap.fromTo('.donate-cta img', 
            { scale: 1.1 }, 
            {
                scale: 1, 
                ease: "power2.out",
                immediateRender: false,
                scrollTrigger: {
                    trigger: ".donate-cta",
                    start: "top 80%",
                    end: "bottom top",
                    scrub: true,
                    toggleActions: "play none none reverse",
                }
            }
        );
    }

    if (document.querySelector('.shop-cta--left-img')) {
        gsap.to(".image-layout .shop-cta--left-img", {
            y: "-40px",
            rotation: 0,
            ease: "none",
            scrollTrigger: {
                trigger: ".image-layout",
                start: "top 90%",
                end: "bottom top",
                scrub: true,
            }
        });
    }

    if (document.querySelector('.shop-cta--right-img')) {
        gsap.to(".image-layout .shop-cta--right-img", {
            y: "-35px",
            ease: "none",
            scrollTrigger: {
                trigger: ".image-layout",
                start: "top 90%",
                end: "bottom top",
                scrub: true,
            }
        });
    }

    if (document.querySelector('.stats__stat-value')) {
        document.querySelectorAll(".stats__stat-value").forEach(stat => {
    
            let targetNumber = parseInt(stat.innerText.replace(/,/g, ''));
        
            if (!isNaN(targetNumber)) { 
                gsap.fromTo(stat, 
                    { innerText: 0 }, 
                    {
                        innerText: targetNumber,
                        duration: 1, 
                        ease: "power3.out",
                        snap: { innerText: 1 }, 
                        scrollTrigger: {
                            trigger: stat,
                            start: "top 80%", 
                            toggleActions: "play none none none" 
                        },
                        onUpdate: function() {
                            stat.innerText = Math.round(stat.innerText).toLocaleString();
                        }
                    });
            }
        });
    }

    if (document.querySelector('.line-container')) {
        gsap.from(".fifty-years-logo", {
            opacity: 0,
            y: 20,             
            duration: 1.5,
            ease: "power2.out",
            delay: 0.5        
        });
    }

    if (document.querySelector('.line-container')) {

        let mm = gsap.matchMedia();


        mm.add("(min-width: 768px)", () => {

            gsap.set("#star--desktop", { scale: 0, opacity: 0, transformOrigin: "50% 50%" });

            gsap.set("#revealPath--desktop", { 
                drawSVG: "0%", 
                immediateRender: true 
            });

            gsap.to("#revealPath--desktop", {
                drawSVG: "100%", 
                ease: "none",    
                scrollTrigger: {
                    trigger: ".line-container", 
                    start: "top 60%",   
                    end: "bottom 80%",   
                    scrub: 1.5,         
                    onUpdate: (self) => {
                    }
                }
            });

            gsap.to("#star--desktop", {
                scale: 1.4,
                opacity: 1,
                duration: 2.5,   
                ease: "back.out(2)",
                onComplete: () => {
                    gsap.to("#star--desktop", {
                    scale: 1.5, 
                    rotation: -15,
                    duration: 1.5,
                    repeat: -1,
                    yoyo: true,
                    ease: 'power1.inOut',
                });
                },
                scrollTrigger: {
                    trigger: ".line-container",
                    start: "bottom 80%", 
                    toggleActions: "play none none reverse", 
                    
                }
            });
        });


        mm.add("(max-width: 767px)", () => {

            gsap.set("#star--mobile", { scale: 0, opacity: 0, transformOrigin: "50% 50%" });

            gsap.set("#revealPath--mobile", { 
                drawSVG: "0%", 
                immediateRender: true 
            });

            gsap.to("#revealPath--mobile", {
                drawSVG: "100%", 
                ease: "none",    
                scrollTrigger: {
                    trigger: ".line-container", 
                    start: "top 60%",   
                    end: "bottom 80%",   
                    scrub: 1.5,         
                    onUpdate: (self) => {
                    }
                }
            });

            gsap.to("#star--mobile", {
                scale: 1.4,
                opacity: 1,
                duration: 2.5,   
                ease: "back.out(2)",
                onComplete: () => {
                    gsap.to("#star--mobile", {
                    scale: 1.5, 
                    rotation: -15,
                    duration: 1.5,
                    repeat: -1,
                    yoyo: true,
                    ease: 'power1.inOut',
                });
                },
                scrollTrigger: {
                    trigger: ".line-container",
                    start: "bottom 80%", 
                    toggleActions: "play none none reverse", 
                    
                }
            });
        });
    }

    if (document.querySelector('.timeline-element__0')) {
        gsap.to(".timeline-element__0 .before", {
            y: "10px",
            rotation: 40,
            ease: "none",
            scrollTrigger: {
                trigger: ".timeline-element__0",
                start: "top bottom",
                end: "bottom top",
                scrub: true,
            }
        });
    }

    if (document.querySelector('.thank-you-section')) {


        gsap.to(".thank-you-section .before", {
            y: "10px",
            rotation: 40,
            ease: "none",
            scrollTrigger: {
                trigger: ".thank-you-section",
                start: "top bottom",
                end: "bottom top",
                scrub: true,
            }
        });

        gsap.from(".thank-you-image", {
            scrollTrigger: {
                trigger: ".thank-you-image",
                start: "top 85%",
                toggleActions: "play none none none"
            },
            scale: 0,
            rotation: -10, 
            duration: 1.2,
            ease: "elastic.out(1, 0.4)" 
        });

        const childSplit = new SplitText(".thank-you-title", { type: "chars", charsClass: "letter" });

        gsap.from(childSplit.chars, {
            scrollTrigger: {
                trigger: ".thank-you-title",
                start: "top 85%",
            },
            y: 50,
            opacity: 0,
            rotation: 45,
            scale: 2,
            duration: 0.8,
            stagger: 0.05,
            ease: "back.out(3)"
        });
    }
    
}

function shop()
{
    if (document.querySelector('#shipping-postcode')) { 
        document.querySelector('#shipping-postcode').addEventListener("input", function() {
            this.value = this.value.toUpperCase();
        });
    } 
}